import { http } from '@/http'

const BASE = '/operational-payments/batches'

export default {
  listBatches(params) {
    return http.get(BASE, { params: params || {} })
  },
  getBatch(id) {
    return http.get(`${BASE}/${id}`)
  },
  createBatch(data) {
    return http.post(BASE, data)
  },
  upload(id, file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.post(`${BASE}/${id}/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  confirm(id) {
    return http.post(`${BASE}/${id}/confirm`)
  },
  approve(id) {
    return http.put(`${BASE}/${id}/approve`)
  },
  pay(id) {
    return http.put(`${BASE}/${id}/pay`)
  },
  annul(id, reason) {
    return http.put(`${BASE}/${id}/annul`, { reason })
  },
  export(id) {
    return http.get(`${BASE}/${id}/export`, { responseType: 'blob' })
  },
  template(id) {
    return http.get(`${BASE}/${id}/template`, { responseType: 'blob' })
  },
}
